import axiosInstance from './axios';

export interface Device {
    id: string;
    deviceId: string;
    name?: string;
    status: 'ACTIVE' | 'BLOCKED' | 'REVOKED';
    lastSeen?: string;
    lastSyncAt?: string;
    platform?: string;
    hostname?: string;
    activationCode?: {
        code: string;
    };
    sedeId?: string | null;
    sede?: { id: string; nombre: string } | null;
}

/**
 * Obtener lista de dispositivos (opcionalmente filtrados por empresa)
 */
export const getDevices = async (companyId?: string): Promise<Device[]> => {
    const response = await axiosInstance.get<Device[]>('/devices', {
        params: { companyId }
    });
    return response.data;
};

/**
 * Bloquear un dispositivo
 */
export const blockDevice = async (id: string, reason?: string): Promise<Device> => {
    const response = await axiosInstance.patch<Device>(`/devices/${id}/block`, { reason });
    return response.data;
};

/**
 * Desbloquear un dispositivo
 */
export const unblockDevice = async (id: string): Promise<Device> => {
    const response = await axiosInstance.patch<Device>(`/devices/${id}/unblock`);
    return response.data;
};

/**
 * Revocar un dispositivo
 */
export const revokeDevice = async (id: string): Promise<Device> => {
    const response = await axiosInstance.delete<Device>(`/devices/${id}`);
    return response.data;
};

/**
 * Reactivar un dispositivo revocado
 */
export const reactivateDevice = async (id: string): Promise<Device> => {
    const response = await axiosInstance.patch<Device>(`/devices/${id}/reactivate`);
    return response.data;
};

/**
 * Cambiar la sede en la que opera un equipo (el escritorio la toma en su siguiente sincronización)
 */
export const assignDeviceSede = async (id: string, sedeId: string): Promise<Device> => {
    const response = await axiosInstance.patch<Device>(`/devices/${id}/sede`, { sedeId });
    return response.data;
};

export default {
    assignDeviceSede,
    getDevices,
    blockDevice,
    unblockDevice,
    revokeDevice,
    reactivateDevice
};

